
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { MatRadioModule } from '@angular/material/radio';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';



import { RouterModule } from '@angular/router';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrModule } from 'ngx-toastr';

import { AppAuthService } from './auth/app-auth.service';
import { AppRouteGuard } from './auth/auth-route-guard';
import { LoginRouteGuard } from './auth/login-route-guard';
import { BusyDirective } from './directives/busy.directive';
import { EqualValidator } from './directives/equal-validator.directive';

import { LayoutStoreService } from './layout/layout-store.service';
import { AppUrlService } from './nav/app-url.service';
import { CustomizerService } from './services/customizer.service';
import { NavigationService } from './services/navigation.service';
import { ExcelService } from './services/excel.service';
import { AppSessionService } from './session/app-session.service';
import { MatNativeDateModule } from '@angular/material/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SignalRService } from './services/signalR.service';
import { ArrayToTreeConverterService } from './services/array-to-tree-converter.service';
import { TreeDataHelperService } from './services/tree-data-helper.service';
import { NgxBarcodeModule } from 'ngx-barcode';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSortModule } from '@angular/material/sort';

@NgModule({
    imports: [
        MatDialogModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        MatCardModule,
        MatSnackBarModule,
        MatIconModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatTableModule,
        MatMenuModule,
        MatTabsModule,
        MatRadioModule,
        MatGridListModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatMomentDateModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatExpansionModule,
        MatToolbarModule,
        MatAutocompleteModule,
        MatSortModule
    ],
    exports: [
        MatDialogModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        MatCardModule,
        MatSnackBarModule,
        MatIconModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatPaginatorModule,
        MatTableModule,
        MatMenuModule,
        MatTabsModule,
        MatRadioModule,
        MatGridListModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatMomentDateModule,
        MatSlideToggleModule,
        MatTooltipModule,
        MatExpansionModule,
        MatToolbarModule,
        MatAutocompleteModule,
        MatSortModule
    ]
})
export class MaterialModule { };
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        NgxPaginationModule,
        ToastrModule.forRoot()
    ],
    declarations: [
        BusyDirective,
        EqualValidator
    ],
    exports: [
        BusyDirective,
        EqualValidator,
        NgxSpinnerModule,
        NgxBarcodeModule
    ]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                AppSessionService,
                AppUrlService,
                AppAuthService,
                AppRouteGuard,
                LoginRouteGuard,
                LayoutStoreService,
                NavigationService,
                CustomizerService,
                ExcelService,
                SignalRService,
                ArrayToTreeConverterService,
                TreeDataHelperService
            ]
        };
    }
}
